import { createFileRoute, Navigate, Outlet, useRouterState } from "@tanstack/react-router";
import { Grid, Layout, Spin } from "antd";
import { HeaderPendente } from "features/empresa/components/HeaderPendente";
import { ModalEmpresaSituacao } from "features/empresa/components/ModalEmpresaSituacao";
import { Breadcrumbs } from "layout/components/Breadcrumbs";
import { Footer } from "layout/components/Footer";
import { HeaderVersao } from "layout/components/HeaderVersao";
import { Menu } from "layout/components/Menu/Menu";
import { ModalRenovandoToken } from "layout/components/ModalRenovandoToken";
import { TopBar } from "layout/components/TopBar/TopBar";
import { useLayoutStore } from "layout/store";
import { PAGINA_INICIAL_NAO_ADMIN, podeAcessarPagina } from "pages/usuarioRota/acessoPaginas";
import { useMinhasRotas } from "pages/usuarioRota/hooks/useMinhasRotas";

export const Route = createFileRoute("/a")({
	component: LayoutPrivado,
});

const { useBreakpoint } = Grid;

/** Usuário não administrador só acessa as telas da seção "Coletas"; as demais redirecionam para o Fechamento. */
function PaginaPermitida() {
	const pathname = useRouterState({ select: (s) => s.location.pathname });
	const { data, isLoading } = useMinhasRotas();

	if (isLoading) {
		return <Spin className="w-full mt-8" />;
	}

	// Sem resposta do backend, trata como não administrador (mais restritivo)
	if (!podeAcessarPagina(pathname, !!data?.isAdmin)) {
		return <Navigate to={PAGINA_INICIAL_NAO_ADMIN} replace={true} />;
	}

	return <Outlet />;
}

function LayoutPrivado() {
	const screens = useBreakpoint();
	const menuOpen = useLayoutStore((s) => s.menuOpen);
	const menuMobile = useLayoutStore((s) => s.menuMobile);

	// No desktop, menu recolhido esconde o TopBar para liberar altura útil
	const showTopBar = menuMobile || menuOpen;

	return (
		<div className="bg-gray-100">
			<ModalRenovandoToken />
			<ModalEmpresaSituacao />
			<HeaderVersao />

			<Layout className="bg-gray-100 shadow-md">
				<Menu />

				<Layout>
					<HeaderPendente />

					{showTopBar ? (
						<Layout.Header className="sticky top-0 z-[998] border-0 border-b border-solid border-gray-200 bg-white p-0 shadow-none">
							<TopBar />
						</Layout.Header>
					) : null}

					<div className="bg-gray-100" style={{ position: "relative", zIndex: 1 }}>
						<Breadcrumbs />
					</div>

					<Layout.Content className="bg-gray-100" style={{ height: "100%", position: "relative" }}>
						<div className={`w-full mr-auto ${screens.md ? "px-4 pb-4 pt-3" : "px-2 pb-3 pt-2"}`}>
							<PaginaPermitida />
						</div>
					</Layout.Content>

					<Layout.Footer>
						<Footer />
					</Layout.Footer>
				</Layout>
			</Layout>
		</div>
	);
}
